import React, { useContext } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import { Button, Input, notification } from "antd";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import { MailOutlined } from "@ant-design/icons";
import FormItem from "antd/lib/form/FormItem";
import { observer } from "mobx-react-lite";

import AccountStore from "../store/accountStore";
import * as yup from "yup";
import { getCurrentUser } from "../../../../Utility/modules/helpers";

const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
};
const initFormData = { comment: "" };
const modalPropsStyles = { main: { maxWidth: 600 } };

export const RejectRequestDialog = observer(() => {
  const accountStore = useContext(AccountStore);
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: dragOptions,
    }),
    []
  );
  const dialogContentProps = {
    type: DialogType.normal,
    title: ` ${accountStore.selReqItem?.reqcode} request Rejection`,
    subText:
      "Provide your reason for rejecting this new account request  to enable us notify the requestor via mail.",
  };
  return (
    <Dialog
      hidden={!accountStore.showRejectRequestDialog}
      onDismiss={() => {
        accountStore.showRejectRequestDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={400}
    >
      <Formik
        initialValues={initFormData}
        validationSchema={yup.object().shape({
          comment: yup.string().required("Reason for rejection is required"),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            setSubmitting(true);
            const approver = getCurrentUser();
            await accountStore.approveReject({
              requestId: accountStore.selReqItem.requestId,
              type: "rejected",
              comment: values.comment,
              createdBy: approver.fullName,
              reqcode: accountStore.selReqItem.reqcode,
            });
            accountStore.showRejectRequestDialog = false;
          } catch (error) {
            const { body } = error.response;
            notification.error({
              message: "SPARS Feedback",
              description: body.message,
            });
          } finally {
            accountStore.isworking = false;
            setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,

          handleSubmit,
          isSubmitting,
        }) => (
          <Form layout="vertical" onFinish={handleSubmit}>
            <FormItem
              label="Reason for Rejection"
              required
              help={touched.comment && errors.comment}
            >
              <Input.TextArea
                placeholder="Enter a valid reason"
                name="comment"
                rows={5}
                value={values.comment}
                onChange={handleChange}
                allowClear
                prefix={<MailOutlined style={{ color: "#A0AEC0" }} />}
              />
            </FormItem>
            <DialogFooter>
              <Button
                type="link"
                onClick={() => {
                  accountStore.showRejectRequestDialog = false;
                }}
              >
                Cancel
              </Button>
              <Button type="danger" htmlType="submit" loading={isSubmitting}>
                Reject
              </Button>
            </DialogFooter>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
});

